import { saveAs } from 'file-saver'

// export const FileSaver = (url) => {
//     const downloadImage = () => {
//         const fileName = url.split('/').pop();
//         saveAs(url, fileName);
//     }
//     return downloadImage
// }

export const FileSaver = (url) => {
    if (!url) return;

    const fileName = url.split('/').pop();
    saveAs(url, fileName);
}